module.exports = __webpack_public_path__ + "img/rankinctr.921a60b7.jpg";